import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MediaModule } from '@spartacus/storefront';
import { KnBrSalesCheckoutService } from 'src/app/services/kn-br-sales-checkout.service';
import { KnBrPhoneHelper } from 'src/app/shared/helpers/kn-br-phone-helpers';

@Component({
    selector: 'knbr-knbr-sales-order-confirmation',
    imports: [MediaModule],
    templateUrl: './knbr-sales-order-confirmation.component.html',
    styleUrl: './knbr-sales-order-confirmation.component.scss',
    providers: [DatePipe],
})
export class KnbrSalesOrderConfirmationComponent implements OnInit {
    orderConfirmationData: any
    isLabels = false;
    
    constructor(private KnBrCheckoutService: KnBrSalesCheckoutService,
        private router: Router,
        private knBrPhoneHelper: KnBrPhoneHelper,
        private datePipe: DatePipe,) {}

    ngOnInit(): void {
        const data: any = this.KnBrCheckoutService.getOrderConfirmData();
        this.isLabels = String((data as any)?.cartCategoryBrand || '').toLowerCase().includes('labels');
        this.orderConfirmationData = data;
        if (!this.orderConfirmationData) {
            this.gotoShopping();
        }
    }

    gotoShopping() {
        this.router.navigateByUrl('search/active-brands');
    }

    // ✓ Format phone number for display
    getFormattedPhone(): string {
        const phone = this.orderConfirmationData?.deliveryAddress?.phone;
        if (!phone) return '';
        return this.knBrPhoneHelper.formatPhoneNumber(phone);;
    }

    formatDisplayDate(value: string | Date): string {
        if (!value) {
            return '';
        }
        return this.datePipe.transform(value, 'MMMM d, y') || String(value);
    }

    resolveImageUrl(item: any): string {
        return this.KnBrCheckoutService.resolveImageUrl(item);
    }
}
